import Expert from "../../components/Expert/Expert";
import { TailSpin } from "react-loader-spinner";
import { ImSad } from "react-icons/im";
import "./results.css";

const Results = ({
  price,
  when,
  where,
  sizeBand,
  performer,
  playingTime,
  dj,
  buttonClicked,
}) => {
  return (
    <div className="results-container">
      <div className="response">
        <p>
          <span className="yolo">Date:</span>{" "}
          <span className="sup">{when}</span>{" "}
        </p>
        <p>
          <span className="yolo">Location:</span>{" "}
          <span className="sup">{where}</span>{" "}
        </p>
        <p>
          <span className="yolo">Band Size:</span>{" "}
          <span className="sup">{sizeBand.value}</span>{" "}
        </p>
        <p>
          <span className="yolo">Performer:</span>{" "}
          <span className="sup">{performer.value}</span>{" "}
        </p>
        <p>
          <span className="yolo">DJ:</span>{" "}
          <span className="sup">{dj.value}</span>{" "}
        </p>
        <div className="hola">
          <p className="price-title">Estimated Price: </p>
          <p className="price">
            {price.toLocaleString("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 0,
            })}
          </p>
        </div>
      </div>
      <div>
        <button className="button2">Send Booking Request</button>
      </div>
    </div>
  );
};

export default Results;
